module.exports = __webpack_public_path__ + "static/media/MHRM82N0002.7550c055.svg";